import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { AUTH_API_URL, SEO_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'
import axios from 'axios'

export class SeoService {
  static authorization = async (login, password) => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/authorization/?apiKey=4zZxcky0lFWTijDt&Login=${login}&Pass=${password}`
      )

      await this.logger(
        {
          api: `/authorization/?apiKey=4zZxcky0lFWTijDt&Login=${login}&Pass=${password}`
        },
        res
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getStat = token => async () => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=getStat`
      )

      await this.logger(
        {
          api: `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=getStat`
        },
        res
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getStatus = token => async () => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=getStatus`
      )

      await this.logger(
        {
          api: `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=getStatus`
        },
        res
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static inviteClient = token => async () => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=invite`
      )

      await this.logger(
        {
          api: `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=invite`
        },
        res
      )

      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static redirectClient = token => async target => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=redirect&target=${target}`
      )

      await this.logger(
        {
          api: `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=redirect&target=${target}`
        },
        res
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static rejectClient = token => async () => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=reject`
      )

      await this.logger(
        {
          api: `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=reject`
        },
        res
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static reInviteClient = token => async () => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=reinvite`
      )

      await this.logger(
        {
          api: `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=reinvite`
        },
        res
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static startTicket = token => async () => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=start`
      )

      await this.logger(
        {
          api: `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=start`
        },
        res
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static closeTicket = token => async () => {
    try {
      const res = await axios.get(
        SEO_API_URL +
          `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=stop`
      )

      await this.logger(
        {
          api: `/operator/?apiKey=4zZxcky0lFWTijDt&token=${token}&action=stop`
        },
        res
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getDepartments = async () => {
    try {
      const res = await axios.get(
        SEO_API_URL + `/getDepartments/?apiKey=4zZxcky0lFWTijDt&Status=1`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getUser = async () => {
    try {
      const res = await HTTPHandler.get(`${AUTH_API_URL}/seo/getUser`)
      const response = formatResponse(res)
      await this.logger(
        {
          api: 'AUTH_API_URL/seo/getUser'
        },
        res
      )
      if (response.status === 200) {
        const user = response.data?.[0]
        return await this.authorization(user.Login, user.Password)
      }
    } catch (e) {
      return createError(e)
    }
  }

  static logger = async (request = {}, response = {}) => {
    try {
      const res = await HTTPHandler.post(
        `${AUTH_API_URL}/seo/saveSeoRequestBody`,
        {
          request,
          response
        }
      )
    } catch (e) {
      return createError(e)
    }
  }
}
